import { useState, useEffect } from "react";

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = new Date(targetDate) - now;

    if (difference <= 0) {
      return { months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const months = Math.floor(difference / (1000 * 60 * 60 * 24 * 30));
    const days = Math.floor((difference % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { months, days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex gap-[5px] md:gap-3">
      <div className="font-CanelaDeck bg-chestnut-rose w-[60px] md:w-24 rounded-lg p-2 text-center">
        <div className="text-xl md:text-4xl font-bold bg-black/20 text-white rounded-t-lg pb-[10px] pt-[8px]">{String(timeLeft.months).padStart(2, "0")}</div>
        <div className="text-[11px] md:text-xs xls:text-sm font-normal md:font-semibold text-white mt-1 md:mt-3">Month</div>
      </div>
      <div className="font-CanelaDeck bg-chestnut-rose w-[60px] md:w-24 rounded-lg p-2 text-center">
        <div className="text-xl md:text-4xl font-bold bg-black/20 text-white rounded-t-lg pb-[10px] pt-[8px]">{String(timeLeft.days).padStart(2, "0")}</div>
        <div className="text-[11px] md:text-xs xls:text-sm font-normal md:font-semibold text-white text-center mt-1 md:mt-3">Day</div>
      </div>
      <div className="font-CanelaDeck bg-chestnut-rose w-[60px] md:w-24 rounded-lg p-2 text-center">
        <div className="text-xl md:text-4xl font-bold bg-black/20 text-white rounded-t-lg pb-[10px] pt-[8px]">{String(timeLeft.hours).padStart(2, "0")}</div>
        <div className="text-[11px] md:text-xs xls:text-sm font-normal md:font-semibold text-white mt-1 md:mt-3">Hours</div>
      </div>
      <div className="font-CanelaDeck bg-chestnut-rose w-[60px] md:w-24 rounded-lg p-2 text-center">
        <div className="text-xl md:text-4xl font-bold bg-black/20 text-white rounded-t-lg pb-[10px] pt-[8px]">{String(timeLeft.minutes).padStart(2, "0")}</div>
        <div className="text-[11px] md:text-xs xls:text-sm font-normal md:font-semibold text-white mt-1 md:mt-3">Minutes</div>
      </div>
      <div className="font-CanelaDeck bg-chestnut-rose w-[60px] md:w-24 rounded-lg p-2 text-center">
        <div className="text-xl md:text-4xl font-bold bg-black/20 text-white rounded-t-lg pb-[10px] pt-[8px]">{String(timeLeft.seconds).padStart(2, "0")}</div>
        <div className="text-[11px] md:text-xs xls:text-sm font-normal md:font-semibold text-white mt-1 md:mt-3">Seconds</div>
      </div>
    </div>
  );
};

export default CountdownTimer;
